import { SUBSCRIPTIONS } from "app/constants/subscriptions";

export const DIGITAL_CARD_CODES = {
  HID_MOBILE: 'HidMobileAccess',
  SALTO: 'SaltoSpace',
  HID_APPLE_WALLET: 'HidAppleWallet',
  WAVELYNX: 'Wavelynx'
} as const;

export class DigitalCardSystemsDB {
    public static system = [
        {
            "code": DIGITAL_CARD_CODES.HID_MOBILE,
            "langKey": "hid_mobile_access",
            "subscriptionKey": SUBSCRIPTIONS.HID_MOBILE
        },
        {
            "code": DIGITAL_CARD_CODES.SALTO,
            "langKey": "salto_space",
            "subscriptionKey": SUBSCRIPTIONS.SALTO
        },
        {
            "code": DIGITAL_CARD_CODES.WAVELYNX,
            "langKey": "wavelynx",
            "subscriptionKey": SUBSCRIPTIONS.WAVELYNX
        },
        {
            "code": DIGITAL_CARD_CODES.HID_APPLE_WALLET,
            "langKey": "hid_apple_wallet",
            "subscriptionKey": SUBSCRIPTIONS.HID_APPLE_WALLET
        }
    ]
}
